<template>
    <div class="dealer-locator__result-image-container">

        <picture v-if="dealer.image && !imageError">
            <source
                :srcset="`${dealer.image}.webp, ${dealer.image}@2x.webp 2x`"
                type="image/webp"
            />
            <img
                loading="lazy"
                :srcset="`${dealer.image}.jpg, ${dealer.image}@2x.jpg 2x`"
                class="dealer-locator__result-image"
                :alt="dealer.name"
                @error="onImageError"
            />
        </picture>

        <img
            v-else
            loading="lazy"
            class="dealer-locator__result-image"
            src="/images/dealers/example-dealer-image@2x.webp"
            :alt="`${dealer.name} - Photo Coming Soon`"
        >
        <!-- src="/images/dealers/image-coming-soon.svg" -->
        <div v-if="dealer.coming_soon" class="dealer-locator__result-coming-soon">
            Opening Soon!
        </div>

    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: 'ThumbnailPicture',

    props: {
        dealer: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            imageError: false,
        }
    },

    methods: {
        onImageError() {
            this.imageError = true
        }
    }
})
</script>